import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import Logo from './Logo';
import ScrollToTopLink from './ScrollToTopLink';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="space-y-4">
            <Logo isFooter variant="small" />
            <p className="text-gray-400 mt-4">
              Expert Maintenance Solutions, votre partenaire de confiance en maintenance électrique et informatique.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white/90">Nos Services</h3>
            <ul className="space-y-3">
              <li>
                <ScrollToTopLink to="/services/reseau" className="text-gray-400 hover:text-white transition-colors">
                  Réseau Informatique
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink to="/services/electricite" className="text-gray-400 hover:text-white transition-colors">
                  Électricité
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink to="/services/fibre" className="text-gray-400 hover:text-white transition-colors">
                  Fibre Optique
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink to="/services/video" className="text-gray-400 hover:text-white transition-colors">
                  Vidéosurveillance
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink to="/services" className="text-blue-400 hover:text-blue-300 transition-colors">
                  Voir tous nos services →
                </ScrollToTopLink>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-2">
            <h3 className="text-lg font-semibold mb-4 text-white/90">Contactez-nous</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
                <div>
                  <a href="tel:+212661304185" className="text-gray-400 hover:text-white block transition-colors">
                    +212 6 61 30 41 85
                  </a>
                  <a href="tel:+212690286005" className="text-gray-400 hover:text-white block transition-colors">
                    +212 6 90 28 60 05
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
                <div>
                  <a href="mailto:contact@expertmaintenancesolutions.com" className="text-gray-400 hover:text-white block transition-colors">
                    contact@emsmaroc.com
                  </a>
                  <a href="mailto:commercial@expertmaintenancesolutions.com" className="text-gray-400 hover:text-white block transition-colors">
                    commercial@emsmaroc.com
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
                <p className="text-gray-400">
                  30 Rue Omar Riffi, 20250 Casablanca, Maroc
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>© {new Date().getFullYear()} Expert Maintenance Solutions. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;